import React, { useEffect, useState, useRef } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import Table from 'components/commandpanel/ExperimentPanel/Table';
import './AutoScoreStatus.scss';
import MarcoService from 'business/services/MarcoService';
import { MarcoStatusDTO } from 'business/models/Models';
import { ScoreService } from 'business/services/ScoreService';
import { downloadFile } from 'utils/Global';
import RMCheckboxWithLabel from 'components/customComponents/Controls/RMCheckBoxWithLabel';
import { RMModal } from 'components/modal';
import { FmlxModal } from 'fmlx-common-ui';

interface AutoScoreJobs {
  name: string;
  fileName: string;
  isChecked: boolean;
}

interface Props {
  showModal: boolean;
  setShowModal: any;
}

export default function AutoScoreStatus(props: Props) {
  const { showModal, setShowModal } = props;
  const autoScoreStatusHeader = [
    { value: 'Name', label: 'Name' },
    { value: 'Status', label: 'Status' },
  ];

  const [scoreData, setScoreData] = useState([]);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [scoreJobs, setScoreJobs] = useState<AutoScoreJobs[]>([
    { name: 'Auto Score', fileName: 'ScoringLogs', isChecked: false },
    { name: 'Dispute Score', fileName: 'DisputeLogs', isChecked: false },
    { name: 'Retrain Images', fileName: 'RetrainLogs', isChecked: false },
  ]);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const prevState = usePrevious(showModal);
  async function getMarcoStatus() {
    setShowLoading(true);
    const marcoService = new MarcoService();
    const response: MarcoStatusDTO = await marcoService.getMarcoStatus();
    setScoreData([
      ['MARCO Server : ' + response.marcoServer, response.marcoStatus],
      ['MARCO Model', response.marcoModel],
      ['MARCO Score Active on', response.marcoServerName],
      ['Unscored Images Count', response.unScoredImageCount],
    ]);
    setShowLoading(false);
  }

  useEffect(() => {
    if (prevState == false && showModal == true) {
      getMarcoStatus();
    }
  }, [showModal]);

  const handleCheckboxChange = (index: number) => {
    const updatedJobs = [...scoreJobs];
    updatedJobs[index].isChecked = !updatedJobs[index].isChecked;
    setScoreJobs(updatedJobs);
  };

  const downloadFiles = () => {
    const scoreService = new ScoreService();
    scoreJobs.map(async (job) => {
      if (job.isChecked) {
        const file = await scoreService.downloadScoreLogs(job.fileName);
        downloadFile(file.data, job.fileName);
      }
    });
  };

  const modalData = () => {
    return (
      <div id="autoscorestatus-modal-data-wrapper" className="container">
        <Row id="autoscorestatus-modal-data-row-title">
          <Col id="autoscorestatus-modal-data-col-title">
            <p id="autoscorestatus-modal-data-title-text" className="marco-status-text">
              Auto Scores Status
            </p>
          </Col>
        </Row>

        <Row id="autoscorestatus-modal-data-header">
          {showLoading ? (
            <Col
              id="autoscorestatus-modal-data-header-col-loading"
              md="12"
              style={{ marginBottom: '2vh' }}
              className="d-flex justify-content-center align-middle"
            >
              <Spinner
                id="autoscorestatus-modal-data-loading-spinner"
                animation="border"
                style={{ color: '#F89723' }}
              />
            </Col>
          ) : (
            <Col id="autoscorestatus-modal-data-col-scoredata">
              <div
                id="autoscorestatus-modal-data-scoredata-table"
                className="border border-gray-300 border-2"
              >
                <Table
                  header={autoScoreStatusHeader}
                  data={scoreData}
                  key={Math.random()}
                ></Table>
              </div>
            </Col>
          )}
        </Row>
        <div id="autoscorestatus-modal-data-logfile-text" className="pt-4">
          Log File
        </div>
        <Row id="autoscorestatus-modal-data-scorejobs-checkbox">
          {scoreJobs.map((job, index) => {
            return (
              <RMCheckboxWithLabel
                key={index}
                label={job.name}
                onChange={() => handleCheckboxChange(index)}
                isChecked={job.isChecked}
                disabled={false}
              />
            );
          })}
        </Row>
      </div>
    );
  };

  return (
    <RMModal
      id="autoscorestatus-modal-wrapper"
      showModal={showModal}
      setShowModal={() => setShowModal()}
      body={modalData()}
      dialogClassName="modal-fullw"
      okButtonText="Refresh"
      saveButtonText="Download"
      noButtonText="Close"
      onSave={() => downloadFiles()}
      onOk={() => getMarcoStatus()}
      isSaveAvailable={true}
      showFooterSeparator={true}
      hideCloseButton={true}
      size={FmlxModal.Size.EXTRA_LARGE}
    />
  );
}
